module.exports = __webpack_public_path__ + "img/banner2.19842582.jpg";